import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { FormPageContainer, FormPageHeader } from '@/components/PageLayout';
import { useListReturn } from '@/hooks/useListReturn';
import { useProduct } from '@/hooks/useProductQueries';
import { ROUTES } from '@/routes/routes';

import { EditProductForm } from './EditProductForm';

export const EditProductPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const { goToList } = useListReturn(ROUTES.PRODUCTS);
  const { data: product, isLoading } = useProduct(slug || '');

  if (isLoading) {
    return (
      <FormPageContainer>
        <Spin size="large" style={{ margin: 'auto' }} />
      </FormPageContainer>
    );
  }

  if (!product) {
    return <Navigate to={ROUTES.PRODUCTS} />;
  }

  return (
    <FormPageContainer>
      <FormPageHeader>
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={goToList} />
        <h2>Редагувати продукт</h2>
      </FormPageHeader>
      <EditProductForm product={product} />
    </FormPageContainer>
  );
};
